
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/introducing-mui-x-chat-v9-alpha",
      function () {
        return require("private-next-pages/blog/introducing-mui-x-chat-v9-alpha.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/introducing-mui-x-chat-v9-alpha"])
      });
    }
  